import {
  APEX_HOST,
  DEFAULT_ISLAND_KEY,
  ISLAND_KEYS,
  getIslandBaseUrl,
  getIslandConfig,
  getSiteVariantFromHostname,
} from 'alakai-aloha-shared';

function normalizeHostname(value = '') {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, '')
    .replace(/\/.*$/, '')
    .replace(/:\d+$/, '');
}

export function getRuntimeHostname() {
  if (typeof window !== 'undefined' && window.location?.hostname) {
    return normalizeHostname(window.location.hostname);
  }

  return normalizeHostname(process.env.REACT_APP_SITE_HOST);
}

function getLocalPreviewIsland(host) {
  if (
    typeof window === 'undefined' ||
    (host !== 'localhost' && host !== '127.0.0.1')
  ) {
    return null;
  }

  const island = new URLSearchParams(window.location.search).get('island');
  return ISLAND_KEYS.includes(island) ? island : null;
}

export function getRuntimeSiteContext() {
  const host = getRuntimeHostname();
  const siteVariant = getSiteVariantFromHostname(host);
  const localPreviewIsland = getLocalPreviewIsland(host);
  const isApexHost = siteVariant === 'apex' || host === APEX_HOST || host === `www.${APEX_HOST}`;
  const activeIsland = localPreviewIsland || (!isApexHost && siteVariant ? siteVariant : DEFAULT_ISLAND_KEY);
  const islandConfig = getIslandConfig(activeIsland);

  return {
    host,
    siteVariant: isApexHost ? 'apex' : activeIsland,
    island: activeIsland,
    islandConfig,
    recognizedIslandHost: Boolean(siteVariant && !isApexHost),
    isApexHost,
    siteMode: isApexHost ? 'apex' : 'island',
    siteUrl: isApexHost ? `https://${APEX_HOST}` : getIslandBaseUrl(activeIsland),
  };
}

export function getRuntimeIslandKey() {
  return getRuntimeSiteContext().island;
}
